import { streakTier } from '../lib/streak';

export function StreakDot({ streak }: { streak: number }) {
  const tier = streakTier(streak);
  if (tier === 0) return null;
  return <span className={`streak-dot streak-dot--t${tier}`} aria-hidden="true" />;
}
